var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-file-input',{attrs:{"label":((_vm.$vuetify.lang.t('$vuetify.io.completes.title')) + "*"),"multiple":"","chips":"","accept":".dic,.text,.DIC,.TEXT"},on:{"change":_vm.onChange},scopedSlots:_vm._u([{key:"selection",fn:function(ref){
var index = ref.index;
var text = ref.text;
return [_c('v-chip',{attrs:{"color":"deep-purple accent-4","dark":"","label":"","small":""}},[_vm._v(" "+_vm._s(text)+" ")])]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }